
interface TimelineStepProps {
  timeframe: string;
  title: string;
  description: string;
  bgColor: string;
  textColor: string;
}

const TimelineStep = ({ timeframe, title, description, bgColor, textColor }: TimelineStepProps) => {
  return (
    <div className="flex items-start space-x-4">
      <div className={`flex-shrink-0 w-8 h-8 ${bgColor} ${textColor} rounded-full flex items-center justify-center text-sm font-semibold`}>
        {timeframe}
      </div>
      <div>
        <h4 className="font-semibold text-gray-900">{title}</h4>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default TimelineStep;
